import Button from 'components/actions/Button';

import './_styles.scss';

interface TabContentHeaderProps {
    title: string;
    message?: string;
    buttonLabel?: string;
    buttonClick?(): void;
    isButtonDisabled?: boolean;
    isButtonVisible?: boolean;
    iconClick?(): void;
}

const TabContentHeader = ({
    title,
    message,
    buttonClick,
    buttonLabel,
    isButtonDisabled,
    isButtonVisible = true,
    iconClick,
}: TabContentHeaderProps) => (
    <div className='TabContentHeader'>
        <div className='TabContentHeader__header'>
            <h5 className='TabContentHeader__title' data-testid={`system-admin-tab-content-header-title-${title}`}>
                {title}
            </h5>
            {message && (
                <p className='TabContentHeader__label' data-testid={`system-admin-tab-content-header-message-${title}`}>
                    {message}
                    {!!iconClick && (
                        <span
                            className='rioglyph rioglyph-info-sign text-15 ml-5 cursor-pointer text-gray-dark'
                            onClick={iconClick}
                        />
                    )}
                </p>
            )}
        </div>
        {!!buttonLabel && !!buttonClick && !!isButtonVisible && (
            <Button
                data-testid={`system-admin-tab-content-header-button-${title}`}
                style='primary'
                onClick={buttonClick}
                disabled={isButtonDisabled}
            >
                <span className='rioglyph rioglyph-plus' />
                {buttonLabel}
            </Button>
        )}
    </div>
);
export default TabContentHeader;
